import $ from 'jquery';
import formInit from "./forms.js";
import {setPositionCalculating} from "../pages_js/home.js";

function copyLinkName($elem) {
    let linkName = $elem.text().trim();
    let goBackBtnTitle = $elem.closest('.header__menu').find('.go-level-back .link__title');
    goBackBtnTitle.text(linkName);
}

function copyInnerList($currentLink, secondLevelHeaderContent) {
    let innerListCopy = $currentLink.find('+ .inner-level-list .header__menu__list').clone(true);
    secondLevelHeaderContent.html('').append(innerListCopy);
}

const headerInit = ()=>{
    $('.link').mouseenter(function (){
        if(window.innerWidth >= 1280)
            $(this).find('.dropdown').fadeIn(200).addClass('show');
    }).mouseleave(function (){
        if(window.innerWidth >= 1280)
            $(this).find('.dropdown').fadeOut(200).removeClass('show');
    }).click(function (){
        if(window.innerWidth < 1280)
            $(this).find('.dropdown').slideToggle(200).toggleClass('show');
    });

    const {simpleFormInit, initializeAirportSearch} = formInit();
    simpleFormInit('#company-form', true);
    simpleFormInit('#travelers-form', true);


    let animation = {easing : 'ease-out'}
    // const searchElm = $('.header__search');
    const searchTriggerElms = $('[data-search-trigger]');
    const bgShadow = $('.bg-shadow');
    const bgShadow2 = $('.bg-shadow2');

    const $menuWrapper = $('.header__menu__mobile__wrapper');
    const $headerLogo = $('.header__logo');
    let firstLevelHeader = $('#first-level-header');
    let secondLevelHeader = $('#second-level-header');
    let secondLevelHeaderContent = secondLevelHeader.find('.content');
    let $calendarModal = $('#calendar-modal');

    $('[data-menu-trigger]').on('click', function (){
        if(window.innerWidth <= 1280){
            switchLevels(firstLevelHeader, secondLevelHeader);
            $menuWrapper.slideToggle(200);
            $menuWrapper.addClass('modal-opened');
            bgShadow.fadeIn(200);
            turnOffScrollbar();
        }

    });
    function fixVH() {
        document.documentElement.style.setProperty('--vh', document.documentElement.clientHeight * 0.01 + 'px');
    }
    window.addEventListener('resize', fixVH);
    fixVH();

    bgShadow.on('click', function (){
        closeModal($('.modal-opened'));
        $('#feedback-in-modal').fadeOut(200);
        bgShadow.fadeOut(200, ()=>turnOnScrollbar());
    })
    $('[data-menu-close]').on('click', function (){
        closeModal($('.modal-opened'));
        bgShadow.fadeOut(200, ()=>turnOnScrollbar());
    })
    // $(window).on('scroll', calculateHeaderPosition)

    let languageMobileSelect = $('#mobile-language-select');
    $('.dropdown__language').click(function (event){
        if(window.innerWidth < 1280){
            languageMobileSelect.slideToggle(200);
            languageMobileSelect.addClass('modal-opened');
            bgShadow.fadeIn(200);
            turnOffScrollbar();
        }
    })


    $('.to-next-level').click(function (){
        let $currentLink = $(this)
        copyLinkName($currentLink);

        copyInnerList($currentLink, secondLevelHeaderContent);

        switchLevels(secondLevelHeader, firstLevelHeader);
    })
    $('.go-level-back').click(function (){
        switchLevels(firstLevelHeader, secondLevelHeader);
    })
    $(".modal-form__switcher").on("click", function () {
        let target = $(this).data("form-switch-target");
        let $targetForm = $(target);
        let $forms = $(".modal-form__wrapper .form__wrapper");

        if ($targetForm.is(":visible")) return;

        $(".modal-form__switcher").removeClass("active");
        $(this).addClass("active");

        $forms.filter(":visible").fadeOut(0, function () {
            $targetForm.fadeIn(0);
        });
    });

    let btnsAndDropDownsList = [];
    $('.btn-open-mobile-modal.calendar, .btn-open-mobile-modal.airport').each((i, btn)=>{
        let dropDown = $(btn.dataset.modalTarget)[0];
        let entry = {
            'btn': btn,
            'dropdown' : dropDown,
            'isAdvanced' : btn.classList.contains('calendar')
        }
        btnsAndDropDownsList.push(entry);
        setPositionCalculating(btnsAndDropDownsList);
    })

    setPositionCalculating(btnsAndDropDownsList);
    const $modalForm = $('.modal-form__container');

    $('.btn-get-quote').on('click', function (){

        $modalForm.addClass('modal-opened');
        if (window.innerWidth >= 768)
            $modalForm.fadeIn(200);
        else
            $modalForm.slideDown(200);
        bgShadow.fadeIn(200);
        turnOffScrollbar();
        setPositionCalculating(btnsAndDropDownsList);
    })

    const {initiateFlatPikr} = formInit();

    $('.btn-open-mobile-modal').on('click', function (){
        let $btn = $(this);
        let modalTargetId = $btn.attr('data-modal-target')
        let inputTargetId = $btn.attr('data-input-target')

        let $modalTarget = $(modalTargetId);
        if(window.innerWidth < 768){
            $modalTarget.slideDown(200).addClass('modal-opened');
            bgShadow.fadeIn(200);
        } else {
            $modalTarget.fadeIn(200).addClass('modal-opened');
        }
        if ($btn.hasClass('airport')){
            setPositionCalculating(btnsAndDropDownsList);
            $modalTarget.find('.select2-search__field')[0].focus();
        }
        if ($btn.hasClass('calendar')){
            let $wrapper = $modalTarget.find('.flatpickr__wrapper');
            initiateFlatPikr(inputTargetId, $wrapper[0]);
            setPositionCalculating(btnsAndDropDownsList);
        }
    });

    $('[data-close]').on('click', function (){
        let $target = $(this);
        let closeId = $target.attr('data-close');
        let $modal = $(closeId).slideUp(200);
        if ($modal.is('[data-close-shadow]')){
            $('.bg-shadow').fadeOut(300);
        }
        if ($modal.is('.modal-opened'))
            $modal.removeClass('modal-opened');
    });

    let $calendarBtns = $('[data-modal-target]')

    $(document).on('click', function (e){
        let $target = $(e.target);
        if(!$target.is('#calendar-modal, #calendar-modal *, .label__wrapper:has(.input__date) *')){
            if (window.innerWidth >= 768)
                $calendarModal.fadeOut(300);
            else
                $calendarModal.slideUp(300);
        }
        $calendarBtns.each((i, btn)=>{
            let $btn = $(btn);
            let modalId = $btn.attr('data-modal-target');
            let $modal = $(modalId);
            let inputId = $btn.attr('data-input-target');
            closeAtMissClick(`${modalId}, ${modalId} *, .label__wrapper:has(${inputId}) *`, $target, $modal);
        });
    });

    $('[data-menu-close-feedback]').on('click', function (){
        $(this).closest('#feedback-in-modal').removeClass('in-modal-opened').fadeOut(200);
    });

    initializeAirportSearch('#depart-2', $('#airport-search-modal-3 .select2__wrapper'));
    initializeAirportSearch('#arrive-2', $('#airport-search-modal-4 .select2__wrapper'));
}

function switchLevels(levelToShow, levelToHide){
    levelToShow.fadeIn(0).removeClass('strong-hidden');
    levelToHide.fadeOut(0).addClass('strong-hidden');
}

function closeAtMissClick (selector, $target, $modal){
    if(!$target.is(selector)){
        $modal.fadeOut(300).removeClass('modal-opened');


    }
}

export function closeModal($modal){
    if(window.innerWidth >= 768)
        $modal.fadeOut(200)
    else
        $modal.slideUp(200);
    $modal.removeClass('modal-opened');
    if ($modal.is('[data-close-shadow]')){
        $('.bg-shadow').fadeOut(300);
    }
}

function getScrollWidth(){
    return window.innerWidth - document.documentElement.clientWidth;
}

export function turnOffScrollbar(){
    let scrollW = getScrollWidth() + 'px';
    $(document.body).css({
        'padding-right': scrollW,
        'overflow' : 'hidden'
    });
}

export function turnOnScrollbar(){
    $(document.body).css({
        'padding-right': '0px',
        'overflow' : 'initial'
    });
}

let lastScrollTop = 0; // Начальная позиция скролла
const header = document.querySelector('header.header');
let lastTopPosition = 0;

function calculateTop(scrollDiff, headerHeight){
    let diff = lastTopPosition - scrollDiff;
    let scrollBordered = Math.max(0, Math.min(diff, headerHeight));
    lastTopPosition = scrollBordered;
    return -scrollBordered;
}
function calculateHeaderPosition(){
    let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    let lastAndCurrentScrollDiff = currentScrollTop - lastScrollTop;
    let calculatedTop = calculateTop(-lastAndCurrentScrollDiff, 136);
    header.style.top= calculatedTop + 'px';
    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // Для предотвращения отрицательных значений

}

export default headerInit;
